/**
 * ============================================================================
 *  File        : frontend/src/components/ui/input.tsx
 *  Module      : components::ui
 *  Purpose     : shadcn/ui input primitive
 *  Author      : EF Engineering
 *  Created     : 2026-05-31
 *  Updated     : 2026-05-31
 *  License     : Proprietary - ECO FAITH Platform v3.0
 * ============================================================================
 */

import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '../../lib/cn'

export type InputProps = InputHTMLAttributes<HTMLInputElement>

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
)
Input.displayName = 'Input'
